/*
 *
 *   SugarWOD
 *   modals.js
 *
 */

function modalLoadUrl(url, size = "md") {
    // use existing modal if available
    let modalEl = $("#modal-form");

    if (modalEl.length) {
        modalEl.empty();
    } else {
        modalEl = $('<div id="modal-form" class="modal">');
    }

    // fill in modal skeleton
    modalEl.append(
        $('<div class="modal-dialog modal-' + size + '">').append(
            $('<div class="modal-content">')
        )
    );

    var modalContentEl = $(".modal-content", modalEl);

    modalContentEl.load(url, function () {
        modalEl.modal({ show: true });
    });

    $("body").append(modalEl);
}

module.exports = {
    modalLoadUrl,
};
